<template>
    <div class="full" v-show="modelValue.status" style="position: fixed;top:0;left:0;user-select: none;"
        @contextmenu.prevent="">
        <div class="full" @click="handle_click" @contextmenu.prevent.stop="handle_click"></div>
        <RightMenuList :setting="childInfo" :data="data" :theme="theme" :item-size="itemSize"></RightMenuList>
    </div>
</template>
<script>
import RightMenuList from "./rightMenuList";

export default {
    name: "RightMenu",
    components: { RightMenuList },
    props: {
        data: Array,//菜单数据
        modelValue: {
            type: Object,
            default() {
                return {
                    status: false,
                    x: 0,
                    y: 0,
                }
            }
        },//设置入口
        theme: {//主题
            type: String,
            default: 'light',
        },
    },
    data() {
        return {
            itemSize: {
                width: 220,
                height: 30,
            },
            childInfo: {
                status: false,
                x: 0,
                y: 0,
            },
        }
    },
    watch: {
        modelValue: {
            handler(n) {
                if (n.status) {
                    this.calculatePosition();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        /**
         * 计算菜单生成位置
         */
        calculatePosition() {
            let x = 0;
            let y = 0;
            let screen = this.getScreen();
            let childHeight = this.data.length * this.itemSize.height;
            if (screen.width - this.modelValue.x <= this.itemSize.width) {
                x = screen.width - this.itemSize.width;
            } else {
                x = this.modelValue.x;
            }
            if (screen.height - this.modelValue.y <= childHeight) {
                y = screen.height - childHeight - 30;
            } else {
                y = this.modelValue.y;
            }
            this.childInfo = {
                status: true,
                x: x,
                y: y,
            }
        },
        /**
         * 获取窗口大小
         */
        getScreen() {
            return {
                width: document.body.clientWidth,
                height: document.body.clientHeight,
            }
        },
        /**
         * 统一关闭菜单入口
         */
        close() {
            this.childInfo = {
                status: false,
                x: 0,
                y: 0,
            }
            // this.$event.$emit("RightMenuListClose");
            this.$emit('update:modelValue', { status: false, x: 0, y: 0 });
        },
        /**
         * 单击空白地方，左右键通用
         */
        handle_click(event) {
            this.close();
            setTimeout(() => {
                document.elementFromPoint(event.clientX, event.clientY).dispatchEvent(event);
            }, 10);
        },
    }

}
</script>
<style scoped>
.full {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
}
</style>